import { SIGNIN } from "constants/urls";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: SIGNIN,
    lazy: () => import("./pages/auth-signin"),
  },
] as RouteObject[];
